import { Metadata } from '../../../../../utils/spds/metadata';
import Super from '../base.gjs';
import styles from './warning.module.scss';

const METADATA = Metadata.define({
  description: 'Secondary warning badge indicator.',
  name: 'Warning Secondary Badge',
});

export default class SpdsIndicatorBadgeWarningSecondary extends Super {
  static metadata = this.setMetadata(METADATA, import.meta.url);
  secondary = true;
  variantClass = 'spds-indicator-badge-warning';
  variantStyles = styles;
}

export const BADGE_WARNING_SECONDARY_METADATA = SpdsIndicatorBadgeWarningSecondary.metadata;
